

<div id="main-wrapper">
  <app-nav [user]="user" ></app-nav>



  <app-menu></app-menu>


  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- <app-dashboard></app-dashboard> -->

      <div class="row">
        <div class="col-12">
          <!-- <app-barcode></app-barcode> -->
            <div class="card">

                <div class="card-body">


                  <router-outlet *ngIf="user"></router-outlet>
                </div>
            </div>
        </div>
    </div>
    </div>

    <!-- <footer class="footer">
      © 2017 Admin Pro by wrappixel.com
    </footer> -->
  </div>
</div>








<!-- <app-nav [user]="user" ></app-nav>

  <div class="container-fluid">
  <div class="row">
    <div class="col-sm-2 col-12 p-0">
    <app-menu></app-menu>
  </div>
  <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-md-4">

      <router-outlet *ngIf="user"></router-outlet>

    </main>
  </div>
  </div>
</div> -->
